// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__9KjQn","root":"styles_root__+v70j","description":"styles_description__kJStN","note":"styles_note__+ueOW","actions":"styles_actions__r2hEL"};